import { action, createRequestTypes } from '@/utils/actions.utils'
import { authActions, uiActions } from '@/redux/actions'
import { userService } from '@/services'
import { setLanguageCookie, setCatalogIdCookie, setCatalogNameCookie } from '@/utils'
import { DEFAULT_LANGUAGE } from '@/constants'


export const CHECK_EMAIL_AVAILABILITY = createRequestTypes('CHECK_EMAIL_AVAILABILITY')
const checkEmailAvailability = (email) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await userService.checkEmailAvailability(email)
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(CHECK_EMAIL_AVAILABILITY.REQUEST)
	}
	function success(payload) {
		return action(CHECK_EMAIL_AVAILABILITY.SUCCESS, payload)
	}
	function failure(err) {
		return action(CHECK_EMAIL_AVAILABILITY.FAILURE, null, err)
	}
}

export const UPDATE_CLIENT_CODE = createRequestTypes('UPDATE_CLIENT_CODE')
const updateClientCode = ({ userId, clientCode, lang }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await userService.updateClientCode({ userId, clientCode, lang })
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(UPDATE_CLIENT_CODE.REQUEST)
	}
	function success(payload) {
		return action(UPDATE_CLIENT_CODE.SUCCESS, payload)
	}
	function failure(err) {
		return action(UPDATE_CLIENT_CODE.FAILURE, null, err)
	}
}

export const UPDATE_USER_LANGUAGE = createRequestTypes('UPDATE_USER_LANGUAGE')
const updateUserLanguage = (userId, selectedLanguage) => {
	const languageIsoCode = selectedLanguage.isoCode
	return async (dispatch) => {
		try {
			await dispatch(request())
			const res = await userService.updateLanguage(userId, selectedLanguage)
			await dispatch(authActions.getAccountDetails())
			await dispatch(uiActions.setNavigation({ language: languageIsoCode }))
			setLanguageCookie(languageIsoCode)
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(UPDATE_USER_LANGUAGE.REQUEST)
	}
	function success(payload) {
		return action(UPDATE_USER_LANGUAGE.SUCCESS, payload)
	}
	function failure(err) {
		return action(UPDATE_USER_LANGUAGE.FAILURE, null, err)
	}
}

export const UPDATE_USER_ABOUT_YOU = createRequestTypes('UPDATE_USER_ABOUT_YOU')
const updateUserAboutYou = ({ userId, data }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await userService.updateUserAboutYou(userId, data)
			await dispatch(authActions.getAccountDetails())
			if (data?.language?.isoCode) {
				setLanguageCookie(data?.language?.isoCode || DEFAULT_LANGUAGE)
				setCatalogIdCookie(data?.catalogId)
				setCatalogNameCookie(data.catalogId)
				await dispatch(
					uiActions.setNavigation({
						language: data?.language?.isoCode || DEFAULT_LANGUAGE,
						catalog: data.catalogId
					})
				)
			}
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(UPDATE_USER_ABOUT_YOU.REQUEST)
	}
	function success(payload) {
		return action(UPDATE_USER_ABOUT_YOU.SUCCESS, payload)
	}
	function failure(err) {
		return action(UPDATE_USER_ABOUT_YOU.FAILURE, null, err)
	}
}

export const UPDATE_USER_ABOUT_COMPANY = createRequestTypes('UPDATE_USER_ABOUT_COMPANY')
const updateUserAboutCompany = ({ userId, data }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await userService.updateUserAboutCompany(userId, data)
			await dispatch(authActions.getAccountDetails())

			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(UPDATE_USER_ABOUT_COMPANY.REQUEST)
	}
	function success(payload) {
		return action(UPDATE_USER_ABOUT_COMPANY.SUCCESS, payload)
	}
	function failure(err) {
		return action(UPDATE_USER_ABOUT_COMPANY.FAILURE, null, err)
	}
}
export const UPDATE_USERS_PRIVILEGES = createRequestTypes('UPDATE_USERS_PRIVILEGES')
const updateUsersPrivileges = ({ updatedPrivileges }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await userService.updateUsersPrivileges({ updatedPrivileges })
			console.log('res ACTION', res)
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(UPDATE_USER_ABOUT_COMPANY.REQUEST)
	}
	function success(payload) {
		return action(UPDATE_USER_ABOUT_COMPANY.SUCCESS, payload)
	}
	function failure(err) {
		return action(UPDATE_USER_ABOUT_COMPANY.FAILURE, null, err)
	}
}

export const UPDATE_ROLE_CRM = createRequestTypes('UPDATE_ROLE_CRM')
const updateRoleCRM = ({ email, role }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await userService.updateRoleCRM(email, role)
			return dispatch(success(res.data))
		} catch (error) {
			dispatch(failure(error))
			throw error
		}
	}

	function request() {
		return action(UPDATE_ROLE_CRM.REQUEST)
	}
	function success(payload) {
		return action(UPDATE_ROLE_CRM.SUCCESS, payload)
	}
	function failure(err) {
		return action(UPDATE_ROLE_CRM.FAILURE, null, err)
	}
}

export const SEND_USER_INVITATION_TO_COMPANY = createRequestTypes('SEND_USER_INVITATION')
const sendUserInvitationToCompany = ({ email, role, companyId }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await userService.sendUserInvitationToCompany(email, role, companyId)
			return dispatch(success(res.data))
		} catch (error) {
			dispatch(failure(error))
			throw error
		}
	}

	function request() {
		return action(SEND_USER_INVITATION_TO_COMPANY.REQUEST)
	}
	function success(payload) {
		return action(SEND_USER_INVITATION_TO_COMPANY.SUCCESS, payload)
	}
	function failure(err) {
		return action(SEND_USER_INVITATION_TO_COMPANY.FAILURE, null, err)
	}
}

export const GET_USER_INVITATION_BY_COMPANY = createRequestTypes('GET_USER_INVITATION_BY_COMPANY')
const getUserInvitationByCompany = ({ companyId }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await userService.getUserInvitationByCompany(companyId)
			return dispatch(success(res.data))
		} catch (error) {
			dispatch(failure(error))
			throw error
		}
	}

	function request() {
		return action(GET_USER_INVITATION_BY_COMPANY.REQUEST)
	}
	function success(payload) {
		return action(GET_USER_INVITATION_BY_COMPANY.SUCCESS, payload)
	}
	function failure(err) {
		return action(GET_USER_INVITATION_BY_COMPANY.FAILURE, null, err)
	}
}

export const CHECK_USER_INVITATION = createRequestTypes('CHECK_USER_INVITATION')
const checkInvitationByUser = ({ userId }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await userService.checkInvitationByUser(userId)
			return dispatch(success(res.data))
		} catch (error) {
			dispatch(failure(error))
			throw error
		}
	}

	function request() {
		return action(CHECK_USER_INVITATION.REQUEST)
	}
	function success(payload) {
		return action(CHECK_USER_INVITATION.SUCCESS, payload)
	}
	function failure(err) {
		return action(CHECK_USER_INVITATION.FAILURE, null, err)
	}
}



export default {
	checkEmailAvailability,
	updateClientCode,
	updateUserLanguage,
	updateUserAboutYou,
	updateUserAboutCompany,
	updateUsersPrivileges,
	updateRoleCRM,
	sendUserInvitationToCompany,
	getUserInvitationByCompany,
	checkInvitationByUser
}
